import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Arrow Bend Up Right Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "m250.61 105.883-57.894 57.893c-5.255 5.255-14.228 2.85-16.152-4.328a9.65 9.65 0 0 1 2.5-9.325l41.43-41.418h-92.498c-58.59.066-106.072 47.547-106.138 106.138 0 7.428-8.04 12.07-14.473 8.356a9.65 9.65 0 0 1-4.825-8.356C2.633 145.597 58.75 89.48 127.996 89.407h92.497l-41.43-41.418c-5.255-5.255-2.85-14.229 4.328-16.152a9.65 9.65 0 0 1 9.326 2.499l57.893 57.893c3.773 3.77 3.773 9.884 0 13.653" }, null, -1)
  ]))]))
}
export default { render: render }